import { useState, useEffect } from 'react';
import { 
    default as BenchmarksExternal,
} from "./BenchmarksExternal";

export default function Benchmarks({performance, includeHr}) {
 
    const [benchmarkFormatted, setBenchmarkFormatted] = useState([]);

    useEffect(() => {
        let benchmarkFormatted = [];

        performance.benchmarks.map(benchmark => {
            benchmarkFormatted.push({
                title: benchmark.type,
                value: benchmark.name
            });
        });
      
        setBenchmarkFormatted(benchmarkFormatted);
    }, []);

    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm padding-bottom-0">
            {benchmarkFormatted && benchmarkFormatted.length ? (
                <>
                    <h2 className="card-title" data-testid="benchmarkHeader">Benchmarks</h2>
                    <BenchmarksExternal benchmarks={benchmarkFormatted}/>
                </>
            ) : null}
            {includeHr ? <hr /> : null}
        </div>
    </div>

}